import { render, staticRenderFns } from "./MzBundleRecommendations.vue?vue&type=template&id=09acb240&"
import script from "./MzBundleRecommendations.vue?vue&type=script&lang=js&"
export * from "./MzBundleRecommendations.vue?vue&type=script&lang=js&"
import style0 from "./MzBundleRecommendations.vue?vue&type=style&index=0&id=09acb240&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports